/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const HammerBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M10.206 4.791c-.59-.06-1.083.092-1.432.441l-4.956 4.956 1.144 1.143L7.5 8.793l10.293 10.293 1.293-1.293L8.793 7.5l2.416-2.416a3.016 3.016 0 0 0-1.003-.293Zm.201-1.99a5.147 5.147 0 0 1 2.815 1.238c.572.5.528 1.332.054 1.806L11.62 7.5l9.41 9.409a1.25 1.25 0 0 1 0 1.768l-2.354 2.353a1.25 1.25 0 0 1-1.768 0L7.5 11.621l-1.655 1.655a1.25 1.25 0 0 1-1.767 0l-2.204-2.204a1.25 1.25 0 0 1 0-1.768l5.485-5.486c.866-.865 2.002-1.123 3.048-1.017Z" /></svg>);
const Hammer = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={HammerBase} {...rest} ref={ref} />);
export default Hammer;